<script>
import StoryCardClickBehavior from "%/dynamic-component-editor/options/story-card-click-behavior";
import { StoryCommentElementMixin } from "%/dynamic-component-editor/standard-components/story-comment/story-comment-element-mixin";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";

export default {
  name: "StoryCommentAuthorName",
  elementPanelSettings: {
    displayName: "Author Name",
    displayIcon: "text-alt",
    elementGroup: "Story Comments",
    elementType: "element",
  },
  extends: UrlElement,
  mixins: [StoryCommentElementMixin],
  options: [
    StoryCardClickBehavior,
  ],
  computed: {
    label() {
      return this.entity.authorName;
    },
    computedHref() {
      return this.storyHref;
    },
  },
};
</script>
